import script from "./HeaderView.vue?vue&type=script&setup=true&lang=ts"
export * from "./HeaderView.vue?vue&type=script&setup=true&lang=ts"

import "./HeaderView.vue?vue&type=style&index=0&id=a0fce06c&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a0fce06c"]])

export default __exports__